// extracted by mini-css-extract-plugin
module.exports = {"dialogContact":"DialogBlock_dialogContact_WTz9e"};